import React, { useCallback } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { TYPE_OPTIONS } from '../../../contants/createBudget';
import {
  addFormData,
  setEndDateError,
  setNameError,
  setStartDateError,
  setTypeError,
  setUniqueNameError,
} from '../../../features/createBudget/createBudgetSlice';
import { parceBudget } from '../../../helpers/parceBudget';
import BudgetAmountInput from '../BudgetAmountInput';
import BudgetNameInput from '../BudgetNameInput';
import BudgetTypeSelect from './BudgetTypeSelect';
import DateRange from './DateRange';

const SetCustomBudget = () => {
  const dispatch = useDispatch();
  const {
    formData,
    startDateError,
    endDateError,
    amountError,
    typeError,
    nameError,
    uniqueNameError,
  } = useSelector(state => state.createBudget, shallowEqual);

  const updateForm = useCallback(
    patch => dispatch(addFormData({ ...formData, ...patch })),
    [dispatch, formData],
  );

  const handleStartDate = useCallback(
    date => {
      dispatch(setStartDateError(''));
      dispatch(setEndDateError(''));
      updateForm({ start_date: date });
    },
    [dispatch, updateForm],
  );

  const handleEndDate = useCallback(
    date => {
      dispatch(setStartDateError(''));
      dispatch(setEndDateError(''));
      updateForm({ end_date: date });
    },
    [dispatch, updateForm],
  );

  const handleAmountChange = useCallback(
    raw => {
      updateForm({ amount: raw });
    },
    [dispatch, updateForm],
  );

  const handleTypeChange = useCallback(
    value => {
      dispatch(setTypeError(''));
      updateForm({ type: value });
    },
    [dispatch, updateForm],
  );

  const handleNameChange = useCallback(
    value => {
      dispatch(setNameError(''));
      dispatch(setUniqueNameError(''));
      updateForm({ name: value });
    },
    [dispatch, updateForm],
  );

  return (
    <>
      <DateRange
        startDate={formData.start_date}
        endDate={formData.end_date}
        onStartDateChange={handleStartDate}
        onEndDateChange={handleEndDate}
        startDateError={startDateError}
        endDateError={endDateError}
      />

      <BudgetAmountInput
        value={formData.amount}
        error={amountError}
        onChange={handleAmountChange}
        format={parceBudget}
      />

      <BudgetTypeSelect
        value={formData.renew_type}
        error={typeError}
        options={TYPE_OPTIONS}
        onChange={handleTypeChange}
      />

      <BudgetNameInput
        value={formData.name || ''}
        error={nameError || uniqueNameError}
        onChange={handleNameChange}
      />
    </>
  );
};

export default SetCustomBudget;
